import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
  useLocation
} from 'react-router-dom';
import { connect } from 'react-redux';
import useSWR, { SWRConfig } from 'swr';
import ReduxHeader from '@kuaizhan/kz-frame/modules/header';
import { passportStatus } from '@kuaizhan/kz-frame/passport/actions';
import { 
  ContextProvider,
} from '@kuaizhan/kz-frame';
import workspaceSideData from './routers/workspaceSideData';
import getSideData, { flatSideData } from './routers/siteSideData';
import getHeaderData from './routers/headerData';
import { Sider, MainRoute } from './components';
import { OfficialAccountsListPage } from './pages';
import { useTheme, useTitle } from './hooks';
import swrConfig from './requests/swrConfig';
import { getOpenedPluginsAPI } from './requests/plugins'

import { SiteResponse, PluginNav } from './interface/interfaces';

function WorkspaceSideContanier() {
  const theme = useTheme();
  const locationState = useLocation();
  return <Sider 
           sections={workspaceSideData}
           flatSections={workspaceSideData}
           theme={theme}
           pathname={locationState.pathname}
          />
}

function SiteSideContanier(props: any) {
  const locationState = useLocation();
  const { data } = 
    useSWR<SiteResponse<PluginNav[]>>(getOpenedPluginsAPI(props.match.params.siteId));
  useTitle('站点后台')
  let openedPlugins: any[] = []
  if (data && Array.isArray(data.data)) {
    openedPlugins = data.data.map(item => ({
      title: item.title,
      href: item.link,
      linkType: 'outer',
      isOpenNewWindow: true,
    }))
  }

  return (
    <Sider
      sections={getSideData(props.match.params.siteId, openedPlugins)}
      flatSections={flatSideData(props.match.params.siteId)}
      pathname={locationState.pathname}
    />          
  )
}

function RootComponent({
  ds,
  dispatch,
  offline
}: { ds: any, dispatch: any, offline: boolean }) {

  const siteRoutes = flatSideData('').filter(route => route.path);

  useEffect(() => {
    dispatch(passportStatus(ds))
  }, [])

  if (offline) {
    // 如果处于离线状态,跳到登录页
    window.location.assign(`http://${window.location.host}/passport/login?refer=${encodeURI(window.location.href)}`);
    console.log('您已经掉线了~~~');
  }
  
  return (
    <SWRConfig
      value={swrConfig}
    >
      <ContextProvider ds={ds}>
        <BrowserRouter>
          <ReduxHeader crumbData={getHeaderData()} pages={[]} curPage={null} subPages={[]} />
            <Switch>
              <Route path="/v4/workspace" exact component={WorkspaceSideContanier} />
              {siteRoutes.map(route => (
                <Route path={route.path} exact component={SiteSideContanier} />
              ))}
            </Switch>
            <Switch>
              <Route path="/v4/official-accounts" exact component={OfficialAccountsListPage} />
              <Route path="/" component={MainRoute} />
            </Switch>
        </BrowserRouter>
      </ContextProvider>
    </SWRConfig>
  )
}


//@ts-ignore
export default connect(state => ({
  //@ts-ignore
  offline: state.passport.status === 'offline',
  //@ts-ignore
}))(RootComponent);
